import {AgentData} from './agent-page-data';

export class UserPositions {
  chiefs: AgentData[];
  majorAgents: AgentData[];
  agents: AgentData[];
}
